import { render, staticRenderFns } from "./surprise-task.vue?vue&type=template&id=1b843d5e&scoped=true&lang=pug&"
import script from "./surprise-task.vue?vue&type=script&lang=js&"
export * from "./surprise-task.vue?vue&type=script&lang=js&"
import style0 from "./surprise-task.vue?vue&type=style&index=0&id=1b843d5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b843d5e",
  null
  
)

export default component.exports